import Helpers from './../../library/Helpers';

export default class Search {

	constructor() {
		this.instance = self;
		this.lastSearch = false;
	}

	static init() {
		const self = new Search;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on('click', '.js-toggle-search', function(e) {
			e.preventDefault();
			self.toggleSearch();
		});

		$(document).on('click', '.js-close-search', function(e) {
			e.preventDefault();
			self.closeSearch();
		});

		$(document).on('click', '.js-reset-search', function(e) {
			e.preventDefault();
			self.resetSearch($('.js-search-form'));
		});

		$(document).on('click', '.js-search-pagination-link', function(e) {
			e.preventDefault();
			self.searchProducts($('.js-search-form'), $(this).data('page'));
		});

		$(document).on('keyup', '.js-search-products-input', Helpers.debounce(function () {
			if ($(this).val().length >= 3) {
				self.searchProducts($(this).parents('form'));
			}
		}, 500));

		$(document).on('submit', '.js-search-form', function(e) {
			e.preventDefault();

			if (!$(this).hasClass('is-loading')) {
				self.searchProducts($(this));
			}
		});
	}

	toggleSearch() {
		const self = this,
			$search = $('.search'),
			$header = $('.header-main'),
			header = $header.get()[0],
			offset = (header.offsetTop - header.scrollTop + header.clientTop) + $header.outerHeight() - 1;

		$('body').toggleClass('search-open');
		$search.css({top: offset});
	}

	closeSearch() {
		const self = this;
		$('body').removeClass('search-open');
	}

	resetSearch($form) {
		const self = this;

		$form.find('.js-search-page-number').val(1);
		$form.find('.js-search-products-input').val('');
		$('.js-search-count').empty();
		$('.js-search-results').empty();
		$('.js-search-pagination').empty();
	}

	searchProducts($form, page = 1) {
		const self = this;
		let data = {};


		$('.js-search-count').empty();
		$('.js-search-pagination').empty();


		if (page <= 1) {
			$('.js-search-results').empty();
		}

		$form.find('.js-search-page-number').val(page);

		$.each($form.serializeArray(), function(key, field) {
			data[field.name] = field.value;
		});

		self.lastSearch = data.searchTerm;

		oc.progressBar.show();

		$form.addClass('is-loading');

        oc.ajax('searchProducts::onSearch', {
            data: data,
            update: {
            	'searchProducts/results': '@.js-search-results',
				'searchProducts/count': '.js-search-count',
				'searchProducts/pagination': '.js-search-pagination'
			},
			beforeUpdate: function(handler, options) {
				if (page <= 1) {
					$('.js-search-results').empty();
				}
			},
            success: function(dataObj, textStatus, jqXHR) {
				this.success(dataObj, textStatus, jqXHR);

				oc.progressBar.hide();

				window.site.lazyLoad('.js-search-results [data-lazy-img]');

				if (data.searchTerm != self.lastSearch) {
					self.searchProducts($form, page);
				}
            },
            complete: function(data, responseCode, xhr) {
            	$form.removeClass('is-loading');
            }
        });

	}
}

